/* ==========================================================================
   Cloré – Move to Mini Cart After Add to Cart (Expanse 8)
   - Mobile: opens drawer (overlay)
   - Desktop: scrolls to header (so cart is visible) then opens dropdown
   - Triggers automatically after theme dispatches `ajaxProduct:added`
   ========================================================================== */

(function () {
  "use strict";

  // Prevent double-open spam if multiple cart events fire quickly
  let lastOpenAt = 0;

  const DEFAULTS = {
    desktopMinWidth: 990,

    // Desktop scroll style: "smooth" (animated) or "auto" (instant jump)
    scrollBehaviorDesktop: "auto",

    // Only scroll if user is far down the page (avoids annoying jumps near top)
    // Set to 0 to always scroll
    minScrollYToMove: 150,

    // Delay before clicking cart trigger on desktop (lets scroll finish)
    desktopOpenDelayMs: 250,

    // Debounce window between opens
    debounceMs: 800,

    // If true, will still open on mobile (drawer) without scrolling
    openOnMobile: true,

    // Debug logs
    debug: false,
  };

  function log(...args) {
    if (DEFAULTS.debug) console.log("[Cloré MiniCart]", ...args);
  }

  // Finds the header element to scroll into view (desktop)
  function getHeaderEl() {
    return (
      document.querySelector("#SiteHeader") ||
      document.querySelector(".header-section") ||
      document.querySelector("header")
    );
  }

  // Opens the desktop cart dropdown by clicking the cart trigger
  function clickCartTrigger() {
    const cartTrigger =
      document.querySelector('[data-header-cart]') ||
      document.querySelector(".site-header__cart") ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href="/cart/"]') ||
      document.querySelector('[aria-controls*="cart"]') ||
      document.querySelector('[data-drawer-open*="cart"]');

    if (!cartTrigger) {
      log("No cart trigger found.");
      return false;
    }

    cartTrigger.click();
    return true;
  }

  // Opens the mobile drawer cart via theme event
  function openMobileDrawer() {
    try {
      document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
      return true;
    } catch (e) {
      return false;
  }
  }

  // Main: move viewport to mini cart + open it
  function moveToMiniCart(options = {}) {
    const settings = Object.assign({}, DEFAULTS, options);
    const now = Date.now();

    if (now - lastOpenAt < settings.debounceMs) {
      log("Debounced open.");
      return;
    }
    lastOpenAt = now;

    const isDesktop = window.matchMedia(`(min-width: ${settings.desktopMinWidth}px)`).matches;

    // Mobile: open drawer (overlay). No scroll needed.
    if (!isDesktop && settings.openOnMobile) {
      openMobileDrawer();
      return;
    }

    // Desktop: only move if user is below threshold (unless threshold = 0)
    if (settings.minScrollYToMove > 0 && window.scrollY < settings.minScrollYToMove) {
      // Already near top — just open dropdown
      clickCartTrigger();
      return;
    }

    // Scroll to header so dropdown is visible
    const header = getHeaderEl();
    if (header && header.scrollIntoView) {
      header.scrollIntoView({ behavior: settings.scrollBehaviorDesktop, block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: settings.scrollBehaviorDesktop });
    }

    // After scroll, open dropdown
    window.setTimeout(() => {
      clickCartTrigger();
    }, settings.desktopOpenDelayMs);
  }

  // Expose function globally (optional manual testing)
  window.CloreMoveToMiniCart = moveToMiniCart;

  // Auto-run after add-to-cart event
  document.addEventListener("ajaxProduct:added", function (e) {
    // If some flow explicitly requested not to open cart, respect it
    if (e?.detail?.preventCartOpen) {
      log("preventCartOpen=true, skipping.");
      return;
    }

    // If cart add failed or event malformed, do nothing
    if (!e || !e.detail) return;

    moveToMiniCart();
  });


})();
